"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVeteransBannerUrlByCountry = exports.veteransUSBannerUrl = exports.veteransOtherCountryBannerUrl = exports.veteransCABannerUrl = void 0;
const country_1 = require("../enums/country");
exports.veteransCABannerUrl = "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1765911838/default-organization-banners/VeteransCA.jpg";
exports.veteransOtherCountryBannerUrl = "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1765911838/default-organization-banners/VeteransOtherCountry.jpg";
exports.veteransUSBannerUrl = "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1765911838/default-organization-banners/VeteransUS.jpg";
const getVeteransBannerUrlByCountry = (country) => {
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return exports.veteransUSBannerUrl;
    }
    if (country === country_1.OrganizationCountry.Canada) {
        return exports.veteransCABannerUrl;
    }
    return exports.veteransOtherCountryBannerUrl;
};
exports.getVeteransBannerUrlByCountry = getVeteransBannerUrlByCountry;
